// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_e3-j";
export var fulfillmentFormRail = "_e3-i";
export var headerTitleRow = "_e3-l";
export var orderDetailsWrapper = "_e3-g";
export var orderLinkTrigger = "_e3-2";
export var paymentInformationGrid = "_e3-q";
export var paymentSummaryColumn = "_e3-r";
export var phoneShipmentPickerButton = "_e3-e";
export var phoneShipmentPickerButtonContent = "_e3-f";
export var phoneShipmentPickerButtonWrapper = "_e3-d";
export var phoneShipmentPickerTrigger = "_e3-c";
export var shipmentContainer = "_e3-k";
export var shipmentDetailsMainPane = "_e3-h";
export var shipmentNavigationCard = "_e3-a";
export var shipmentNavigationEdgeTrigger = "_e3-6";
export var shipmentNavigationRail = "_e3-3";
export var shipmentNavigationRailEnter = "_e3-5";
export var shipmentNavigationRailHeader = "_e3-9";
export var shipmentNavigationRailOverlay = "_e3-4";
export var shipmentNavigationScrim = "_e3-7";
export var shipmentSummaryFact = "_e3-n";
export var shipmentSummaryGrid = "_e3-m";
export var shipmentSummaryMetadataRow = "_e3-o";
export var shipmentSummaryTags = "_e3-p";
export var shipmentWorkspace = "_e3-0";
export var shipmentWorkspaceBodyTablet = "_e3-8";
export var shipmentWorkspaceContent = "_e3-b";
export var shipmentWorkspaceHeader = "_e3-1";